import { createApi } from "@reduxjs/toolkit/query/react";
import { baseRestQueryResult as baseQuery, showNotification } from "@/services/api";
import { ListResponse } from "@/types/response.type";
import { HouseRental, HouseRentalExpired, HouseRentalForm } from "@/types/house-rental.type";

export const houseRentalApi = createApi({
  reducerPath: "houseRentalApi",
  baseQuery,
  tagTypes:['house-rentals'],
  endpoints: (builder) => ({
    getHouseRentals: builder.query<ListResponse<HouseRental>, {}>({
      query: (data) => ({ url: `house-rental`, params: data }),
      keepUnusedDataFor: 0,
      transformResponse: (rawResult: { data: ListResponse<HouseRental> }, meta) => {
        return rawResult.data
      },
    }),
    getHouseRentalExpired: builder.query<HouseRentalExpired, {}>({
      query: () => ({ url: `house-rental/expired` }),
      keepUnusedDataFor: 0,
      transformResponse: (rawResult: { data: HouseRentalExpired }, meta) => {
        return rawResult.data
      },
    }),
    getHouseRental: builder.query<HouseRental, string>({
      query: (id) => `house-rental/${id}`,
      keepUnusedDataFor: 0,
      transformResponse: (rawResult: { data: HouseRental }, meta) => {
        return rawResult.data
      },
    }),
    addHouseRental: builder.mutation<any, HouseRentalForm>({
      query: (body) => ({
        url: 'house-rental',
        method: 'POST',
        body,
      }),
      async onQueryStarted(body, { queryFulfilled }) {
        try {
          const { data, meta } = await queryFulfilled
          // `onSuccess` side-effect
          showNotification("POST", "success")
        } catch (err: any) {
          
          // `onError` side-effect
          showNotification("POST", "error", err?.error?.data?.message || "error")
        }
      }
    }),
    editHouseRental: builder.mutation<HouseRental, Pick<HouseRental, "id">>({
      query: ({ id, ...body }) => ({
        url: `house-rental/${id}`,
        method: 'PUT',
        body,
      }),
      async onQueryStarted(body, { queryFulfilled }) {
        try {
          const { data, meta } = await queryFulfilled
          // `onSuccess` side-effect
          showNotification("PUT", "success")
        } catch (err: any) {
          
          // `onError` side-effect
          showNotification("PUT", "error", err?.error?.data?.message || "error")
        }
      }
    }),
    deleteHouseRental: builder.mutation<any, string>({
      query: (id) => ({
        url: `house-rental/${id}`,
        method: 'DELETE',
      }),
      async onQueryStarted(id, { queryFulfilled }) {
        try {
          const { data, meta } = await queryFulfilled
          // `onSuccess` side-effect
          showNotification("DELETE", "success")
        } catch (err: any) {
          
          // `onError` side-effect
          showNotification("DELETE", "error", err?.error?.data?.message || "error")
        }
      }
    }),
  }),
});

export const { useGetHouseRentalsQuery, useGetHouseRentalQuery, useGetHouseRentalExpiredQuery, useAddHouseRentalMutation, useEditHouseRentalMutation, useDeleteHouseRentalMutation } = houseRentalApi;
